import { useWorkflowPermission } from './useWorkflowPermission';

interface UseWorkflowEditPermissionResult {
	hasEditPermission: boolean;
	isCheckingEditPermission: boolean;
}

/**
 * Hook that checks whether the current user has edit permission for a workflow.
 *
 * @param workflowId - The workflow ID to check edit permissions for
 * @param userName   - The authenticated user's login name
 */
export function useWorkflowEditPermission(
	workflowId: string | undefined,
	userName: string | undefined
): UseWorkflowEditPermissionResult {
	const { hasPermission, isCheckingPermission } = useWorkflowPermission(workflowId, userName, 'edit');

	return {
		hasEditPermission: hasPermission,
		isCheckingEditPermission: isCheckingPermission,
	};
}
